import React, { ElementType } from 'react'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'

interface DynamicIconButtonProps {
    title: React.ReactNode
    IconComponent: ElementType
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    placement: TooltipProps['placement']
    padding?: string
}

export const DynamicIconButton = ({ title, IconComponent, onClick, placement, padding }: DynamicIconButtonProps) => {
    return (
        <Tooltip title={title} placement={placement}>
            <IconButton
                onClick={onClick}
                aria-label={typeof title === 'string' ? title : undefined}
                sx={padding ? { padding } : null}
            >
                <IconComponent />
            </IconButton>
        </Tooltip>
    )
}
